<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="code"
              label="Product Code"
              type="text"
              class="mr-1"
              v-model="queryParams.code"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="name"
              label="Product Name"
              type="text"
              class="mr-1"
              v-model="queryParams.name"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="brandName"
              label="Brand Name"
              type="text"
              class="mr-1"
              v-model="queryParams.brandName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="categoryName"
              label="Category Name"
              type="text"
              class="mr-1"
              v-model="queryParams.categoryName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field
              name="productGroupName"
              label="Product Group Name"
              type="text"
              class="mr-1"
              v-model="queryParams.productGroupName"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2 v-if="showProductTypeFlag">
            <v-select
              label="Product Type..."
              :items="productTypeList"
              item-text="label"
              item-value="value"
              v-model="queryParams.productType"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 md2 v-if="showStatusFlag">
            <v-select
              label="Status..."
              :items="statusList"
              item-text="label"
              item-value="value"
              v-model="queryParams.status"
            ></v-select>
          </v-flex>
          <v-flex sm2>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-flex xs12 class="mt-1">
          <v-data-table
            :headers="headers"
            :items="productList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td @click="setProduct(props.item)">
                <a>{{ props.item.code }}</a>
              </td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.brand.name }}</td>
              <td>{{ props.item.category.name }}</td>
              <td v-if="props.item.productGroup">
                {{ props.item.productGroup.name }}
              </td>
              <td v-else></td>
              <td>{{ props.item.description }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
  
  
<script>
import { productService } from "../../services/product-service";

export default {
  name: "ProductListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
    showStatusFlag: Boolean,
    showProductTypeFlag: Boolean,
  },

  data: () => ({
    showListLoading: false,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      productType: "",
    },
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    statusList: [
      { label: "---ALL---", value: "" },
      { label: "ACTIVE", value: "ACTIVE" },
      { label: "INACTIVE", value: "INACTIVE" },
    ],
    productTypeList: [
      { label: "---ALL---", value: "" },
      { label: "STANDARD", value: "STANDARD" },
      { label: "PRODUCTION", value: "PRODUCTION" },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    rowsPerPageItems: [10, 50, 100],
    totalRows: 0,
    productList: [],
  }),

  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },

  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = {
            ...this.params,
          };
          this.productList = [];
          this.getProductList();
        }
      },
    },
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },

    setProduct(product) {
      this.dialogClose(product);
    },

    dialogClose(product) {
      this.$emit("close", product);
    },
  },
};
</script>
